import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import { contentfulPropTypes } from '../../propTypes';
import { black, light, solarGradient } from '../../theme/colors';
import withContentfulTag from '../../utils/withContentfulTag';
import SolarIcon from '../../assets/svg/icon/solar-icon.svg';
import { flowSteps, recordFlowProgress } from '../../utils/recordFlowProgress';

const StyledSolarPanel = styled.div`
  bottom: 0;
  position: sticky;
  padding-bottom: 20px;
  text-align: left;
  margin-top: 10px;

  .solar-header {
    border-radius: 4px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid ${light};
    border-bottom: none;
    font-size: 30px;
    font-weight: bold;
    color: ${black};
    background: ${solarGradient};
    padding: 0.8rem 10px 10px;
  }
  .solar-body {
    border-radius: 4px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border: 1px solid ${light};
    border-top: none;
    background: #fff;
    padding: 0.8rem 2.5rem 0.8rem 0.8rem;
  }
`;

const StyledImg = styled.img`
  width: 48px;
  height: 48px;
  margin-bottom: 8px;
`;

const SolarPanel = ({ large, contentful, loading, fetched }) =>
  !loading &&
  fetched && (
    <>
      <StyledSolarPanel className="large">
        <div className="solar-header">
          <div>
            <StyledImg alt="Solar Icon" src={SolarIcon} />
          </div>
          {contentful.title}
        </div>
        <div className="solar-body">
          <ReactMarkdown>{contentful.body}</ReactMarkdown>
        </div>
      </StyledSolarPanel>
      <div className="text-right">
        <Button
          className="mt-0 px-4"
          onClick={async () => {
            await recordFlowProgress(flowSteps.OVERVIEW_SOLAR_PANEL_CTA);
            return (window.location.href = contentful.link);
          }}>
          {contentful.primaryButtonText}
        </Button>
      </div>
    </>
  );

SolarPanel.propTypes = {
  ...contentfulPropTypes,
  large: PropTypes.bool,
};

SolarPanel.defaultProps = {
  large: false,
};

export default withContentfulTag(SolarPanel, 'web_app_solar_panel_large');
